export const BorderedButtonStyles = {
    baseStyles : "text-iw-tertiary font-bold text-[16px] leading-[24px]",
    disabledClasses : "bg-iw-disabled text-white shadow-none cursor-not-allowed"
}